import React from 'react';

import useLocations from 'core/hooks/useLocations';
import { Location as LocationType } from 'core/types/location';

type Props = {
  id: LocationType['id'];
};

export default function Location({ id }: Props) {
  const locations = useLocations();

  if (locations.length === 0) {
    return <>Ladataan...</>;
  }

  const location = locations.find(location => location.id === id);

  return <>{location ? location.name : 'Tuntematon lokaatio'}</>;
}
